let o = 0;
const n = e(), t = e(), a = e(), c = e(), r = e(), s = e(), p = e();
function e() {
  return 2 ** ++o;
}
export {
  n as boolean,
  t as booleanish,
  p as commaOrSpaceSeparated,
  s as commaSeparated,
  c as number,
  a as overloadedBoolean,
  r as spaceSeparated
};
//# sourceMappingURL=types.js.map
